import { Observable } from '@apollo/client';
import { addMinutes, formatISO } from 'date-fns';
// @ts-expect-error TS7016: Could not find a declaration file for module
import DashboardQuery from '../graphql/queries/dashboard.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestDetailQuery from '../graphql/queries/pullRequestDetail.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsQuery from '../graphql/queries/pullRequests.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsByIdsQuery from '../graphql/queries/pullRequestsByIds.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsByRepositoryQuery from '../graphql/queries/pullRequestsByRepository.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import PullRequestsMetricsQuery from '../graphql/queries/pullRequestsMetrics.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import RepositoryListQuery from '../graphql/queries/repositoryList.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommitListQuery from '../graphql/queries/commitList.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommonIssuesQuery from '../graphql/queries/commonIssues.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommitFileIssuesQuery from '../graphql/queries/commitFileIssues.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import CommitDetailAllDataQuery from '../graphql/queries/commitDetailAllData.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import InstallWebhook from '../graphql/mutations/installWebhook.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateVcsAnnotations from '../graphql/mutations/updateVcsAnnotations.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import AutoFixPullRequestQuery from '../graphql/queries/autoFixPullRequest.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import GeneratePullRequestFromDiff from '../graphql/mutations/generatePullRequestFromDiff.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import MeQuery from '../graphql/queries/me.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateUserEmail from '../graphql/mutations/updateUserEmail.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateUserTimezone from '../graphql/mutations/updateUserTimezone.graphql';
// @ts-expect-error TS7016: Could not find a declaration file for module
import UpdateUserNotifications from '../graphql/mutations/updateUserNotifications.graphql';
import BaseModel from './BaseModel';
import Dashboard from './entities/Dashboard';
import PullRequest from './entities/PullRequest';
import PullRequestList from './entities/PullRequestList';
import { timezoneOffsetCalculation } from '../utils/timezoneOffsetCalculation';
import PullRequestsMetricList from './entities/PullRequestMetricList';
import Repository from './entities/Repository';
import CommitList from './entities/CommitList';
import DefectList from './entities/DefectList';
import CommitCodeCoverage from './entities/CommitCodeCoverage';
import CommitDetail from './entities/CommitDetail';
import { replaceAsciiCharWithSlash } from '../utils/resolveBranch';
import AutoFixPullRequest from './entities/AutoFixPullRequest';
import * as types from '../constants/ActionTypes';
import User from './entities/User';
import CommitFile from './entities/CommitFile';
import BranchExistsError from '../errors/BranchExistsError';
export default class ApiV2Model extends BaseModel {
    constructor(client) {
        super();
        this.client = client;
        this.baseQueryOptions = {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        };
    }
    async updateUserEmail(email, dispatch) {
        dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_REQUEST });
        try {
            const { data } = await this.client.mutate({
                mutation: UpdateUserEmail,
                variables: {
                    email,
                },
            });
            dispatch({
                type: types.LOGGED_USER,
                payload: new User(data.updateUserEmail),
            });
        }
        catch (error) {
            dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_FAILURE, payload: error });
            throw error;
        }
    }
    async updateUserTimezone(timezoneId, dispatch) {
        dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_REQUEST });
        try {
            const { data } = await this.client.mutate({
                mutation: UpdateUserTimezone,
                variables: {
                    timezoneId,
                },
            });
            dispatch({
                type: types.LOGGED_USER,
                payload: new User(data.updateUserTimezone),
            });
        }
        catch (error) {
            dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_FAILURE, payload: error });
            throw error;
        }
    }
    async updateUserNotifications(userNotifications, dispatch) {
        dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_REQUEST });
        try {
            const { data } = await this.client.mutate({
                mutation: UpdateUserNotifications,
                variables: {
                    userNotifications,
                },
            });
            dispatch({
                type: types.LOGGED_USER,
                payload: new User(data.updateUserNotifications),
            });
        }
        catch (error) {
            dispatch({ type: types.UPDATE_LOGIN_USER_DETAILS_FAILURE, payload: error });
            throw error;
        }
    }
    async installWebhook(repositoryId) {
        const result = await this.client.mutate({
            mutation: InstallWebhook,
            fetchPolicy: 'network-only',
            variables: {
                id: repositoryId,
            },
        });
        if (!result.data) {
            throw new Error(`Install webhook was unsucessful for the repository: ${repositoryId}`);
        }
        return new Dashboard(result.data.installWebhook);
    }
    async updateAnnotations(repositoryId, enable) {
        const { data } = await this.client.mutate({
            mutation: UpdateVcsAnnotations,
            variables: {
                request: {
                    id: repositoryId,
                    enable,
                },
            },
        });
        return data.status;
    }
    async getMe(dispatch) {
        dispatch({ type: types.LOGIN_USER_DETAILS_REQUEST });
        try {
            const { data } = await this.client.query({
                ...this.baseQueryOptions,
                query: MeQuery,
            });
            const user = new User(data.me);
            dispatch({
                type: types.LOGGED_USER,
                payload: {
                    ...user,
                },
            });
            return user;
        }
        catch (error) {
            dispatch({ type: types.LOGIN_USER_DETAILS_FAILURE, payload: error });
            throw error;
        }
    }
    async getDashboard(vcs, repositoryFullname, branchName) {
        const variables = {
            fullname: repositoryFullname,
            vcs,
        };
        if (branchName) {
            variables.branchName = replaceAsciiCharWithSlash(branchName);
        }
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: DashboardQuery,
            variables,
        });
        return new Dashboard(data.dashboard, branchName);
    }
    async getPullRequestDetail(repositoryId, prId) {
        const variables = {
            repositoryId,
            prId,
        };
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: PullRequestDetailQuery,
            variables,
        });
        return new PullRequest(data.pullRequestDetail);
    }
    /**
     * @deprecated Use getPullRequestList or getPullRequestsByRepository instead
     */
    async getPullRequestList(repositoryIds, prIds) {
        const variables = {
            repositoryId: repositoryIds,
            ...(prIds?.length && { prIds }),
        };
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: PullRequestsQuery,
            variables,
        });
        return new PullRequestList(data.pullRequests);
    }
    async getPullRequestsByRepository(repositoryId) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: PullRequestsByRepositoryQuery,
            variables: {
                repositoryId,
            },
        });
        return new PullRequestList(data.pullRequestsByRepository);
    }
    async getPullRequestsByIds(ids) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: PullRequestsByIdsQuery,
            variables: {
                ids,
            },
        });
        return new PullRequestList(data.pullRequestsByIds);
    }
    watchPullRequestMetrics(timezoneId, activeRepositoriesIds, from, to, pollInterval = 0) {
        const variables = {};
        if (activeRepositoriesIds && activeRepositoriesIds.length !== 0) {
            variables.repositoryIds = activeRepositoriesIds;
        }
        if (from) {
            variables.startDate = formatISO(addMinutes(from, timezoneOffsetCalculation(from, timezoneId)));
        }
        if (to) {
            variables.endDate = formatISO(addMinutes(to, timezoneOffsetCalculation(to, timezoneId)));
        }
        const observableQuery = this.client.watchQuery({
            ...this.baseQueryOptions,
            query: PullRequestsMetricsQuery,
            // eslint-disable-next-line no-undefined
            variables: Object.keys(variables).length ? variables : undefined,
            pollInterval,
        });
        return new Observable((subscriber) => {
            const sub = observableQuery.subscribe({
                next: ({ data }) => {
                    if (data?.pullRequestsMetrics) {
                        subscriber.next(new PullRequestsMetricList(data.pullRequestsMetrics));
                    }
                },
                error: (err) => subscriber.error(err),
            });
            return () => sub.unsubscribe();
        });
    }
    async getRepositoryList(reload) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: RepositoryListQuery,
            variables: {
                reload,
            },
        });
        const repositoriesData = data.repositoryList;
        const repositories = repositoriesData.map((repository) => new Repository({
            ...repository,
            webhookLoading: false,
        }, {
            commits: [],
            currentPage: 1,
            moreCommits: false,
            limit: 10,
        }, {}));
        return repositories;
    }
    async getCommitList(branchId, lastTime = null) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: CommitListQuery,
            variables: {
                branchId,
                ...(lastTime && { lastTime }),
            },
        });
        const commitData = data.commitList;
        return new CommitList(commitData.commits, commitData.limit, commitData.moreCommit, 1, {});
    }
    async getDefectList(commitHash, vcs, limit = 10, onlyNew = false, issuesType) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: CommonIssuesQuery,
            variables: {
                commitHash,
                vcs,
                onlyNew,
                limit,
                ...(issuesType && { issuesType: issuesType.toUpperCase() }),
            },
        });
        const defectList = data.commonIssues;
        return new DefectList(defectList.commonIssues, defectList.totalNodes);
    }
    async getCommitDetailAllData(commitHash, vcs, onlyNew = false, issuesLimit, issuesType) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: CommitDetailAllDataQuery,
            variables: {
                commitHash,
                vcs,
                onlyNew,
                ...(issuesLimit && { limit: issuesLimit }),
                ...(issuesType && { issuesType: issuesType.toUpperCase() }),
            },
        });
        const commitCodeCoverage = new CommitCodeCoverage(data.commitCodeCoverage);
        return {
            commitCodeCoverage,
            commitDetail: new CommitDetail(data.commitDetail, data.commonIssues.commonIssues, commitCodeCoverage),
            defectList: new DefectList(data.commonIssues.commonIssues, data.commonIssues.totalNodes),
        };
    }
    async getAutoFixesForPullRequest(commitHash, vcs) {
        const { data } = await this.client.query({
            ...this.baseQueryOptions,
            query: AutoFixPullRequestQuery,
            variables: {
                commitHash,
                vcs,
            },
        });
        return new AutoFixPullRequest(data.quickFixPullRequest);
    }
    async generatePullRequestFromDiff(variables) {
        const files = variables.files.map((file) => {
            return {
                fixTool: file.fixTool,
                path: file.path,
            };
        });
        try {
            const response = await this.client.mutate({
                mutation: GeneratePullRequestFromDiff,
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
                variables: {
                    request: {
                        ...variables,
                        files,
                    },
                },
            });
            return response.data;
        }
        catch (error) {
            if (error?.networkError?.result?.errors.length && error.networkError.result.errors[0].message === 'Branch exists') {
                throw new BranchExistsError(error.networkError.result.errors[0].message);
            }
            throw error;
        }
    }
    async getCommitFileIssues(dispatch, fileId, commitHash, vcs, onlyNew = false) {
        dispatch({ type: types.GET_COMMIT_FILE_ISSUES_REQUEST });
        try {
            const { data } = await this.client.query({
                ...this.baseQueryOptions,
                query: CommitFileIssuesQuery,
                variables: {
                    fileId,
                    commitHash,
                    vcs,
                    onlyNew,
                },
            });
            dispatch({
                type: types.GET_COMMIT_FILE_ISSUES_SUCCESS,
            });
            return new CommitFile(data.commitFileIssues);
        }
        catch (error) {
            dispatch({ type: types.GET_COMMIT_FILE_ISSUES_FAILURE, payload: error });
            throw error;
        }
    }
}
